import React from "react";
import { Zap, Sparkles, Disc, Dog, Rocket, Cloud, Star, Crown, RefreshCcw } from "lucide-react";
import { RUN_POWERS } from "./upgrades";

const ICONS = { Zap, Sparkles, Disc, Dog, Rocket, Cloud };
const RARITY_LABEL = { common: null, rare: "RARE", epic: "EPIC ✦ +2 LVL" };
const RARITY_BADGE_ICON = { common: null, rare: Star, epic: Crown };

// Free, temporary in-run upgrade picker with rarity tiers. Common cards
// grant +1 level, rare cards +1 (visual flair only), epic cards +2.
// VIP players get one extra card and one free reroll per popup.
export default function RewardModal({ options, runPowers, onChoose, onReroll }) {
  if (!options) return null;
  const rerollsLeft = options.rerollsLeft || 0;
  return (
    <div className="reward-overlay" data-testid="reward-overlay">
      <div className="reward-card-wrap">
        <div className="reward-header">
          <div className="reward-eyebrow">DEADED ENEMY REWARD</div>
          <h2 className="reward-title">Pick a Power</h2>
          <div className="reward-sub">Free in-run upgrade · Lasts for this run</div>
        </div>
        <div className={`reward-grid reward-grid-${options.ids.length}`}>
          {options.ids.map((id, idx) => {
            const p = RUN_POWERS[id];
            const lvl = runPowers[id] || 0;
            const rarity = (options.rarities && options.rarities[idx]) || "common";
            const bump = rarity === "epic" ? 2 : 1;
            const next = Math.min(p.maxLevel, lvl + bump);
            const Icon = ICONS[p.icon] || Sparkles;
            const RarityIcon = RARITY_BADGE_ICON[rarity];
            return (
              <button
                key={id}
                type="button"
                className={`reward-card rarity-${rarity}`}
                onClick={() => onChoose(id)}
                data-testid={`reward-card-${id}`}
              >
                {RARITY_LABEL[rarity] && (
                  <div className={`rarity-badge rarity-badge-${rarity}`}>
                    {RarityIcon && <RarityIcon size={12} strokeWidth={2.6} />}
                    <span>{RARITY_LABEL[rarity]}</span>
                  </div>
                )}
                <div className="reward-icon">
                  <Icon size={36} strokeWidth={2.2} />
                </div>
                <div className="reward-name">{p.name}</div>
                <div className="reward-desc">{p.description}</div>
                <div className="reward-lvl-row">
                  {p.maxLevel <= 6 ? (
                    <div className="reward-lvl-pips">
                      {Array.from({ length: p.maxLevel }).map((_, i) => (
                        <span
                          key={i}
                          className={`pip ${i < lvl ? "on" : ""} ${i >= lvl && i < next ? "next" : ""}`}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="reward-lvl-bar">
                      <div
                        className="reward-lvl-bar-fill"
                        style={{ width: `${(lvl / p.maxLevel) * 100}%` }}
                      />
                    </div>
                  )}
                  <div className="reward-lvl-label">
                    {lvl === 0
                      ? rarity === "epic"
                        ? "NEW ✦ +2"
                        : "NEW"
                      : `Lv ${lvl} → ${next}`}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
        <div className="reward-footer">
          {onReroll && rerollsLeft > 0 && (
            <button
              type="button"
              className="zc-btn reward-reroll-btn"
              onClick={onReroll}
              data-testid="reward-reroll"
            >
              <RefreshCcw size={14} /> VIP Reroll ({rerollsLeft})
            </button>
          )}
          <span className="reward-footer-text">Choose 1 · Free</span>
        </div>
      </div>
    </div>
  );
}
